import { Sync } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";

interface Props {
  refreshingImportedData: boolean;
  handleRefreshImportedData: () => void;
}

const RefreshRtStructsButton = ({
  refreshingImportedData,
  handleRefreshImportedData,
}: Props) => {
  return (
    <Button
      sx={{ width: "190px" }}
      disabled={refreshingImportedData}
      onClick={handleRefreshImportedData}
      startIcon={
        refreshingImportedData ? null : <Sync sx={{ fontSize: "18px" }} />
      }
      variant="outlined"
      data-testid="planning-template-refresh"
    >
      {refreshingImportedData && (
        <CircularProgress
          size={24}
          sx={{ marginRight: "8px", position: "absolute" }}
          color="inherit"
          data-testid="planning-template-refresh-spinner"
        />
      )}
      <span
        style={{
          visibility: refreshingImportedData ? "hidden" : "inherit",
        }}
      >
        Refresh RTStruct
      </span>
    </Button>
  );
};

export default RefreshRtStructsButton;
